<template>
    <div class="programs">
        <ProgramItemBar
            v-for="item in items"
            :key="item.key"
            class="item"
            :item="item"
            @click.native="$emit('on-select', item)"
        />
    </div>
</template>

<script>
import ProgramItemBar from "./ProgramItemBar";

export default {
    name: "ProgramsMobile",

    components: {
        ProgramItemBar,
    },

    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang="scss" scoped>
.programs {
    .item {
        margin-bottom: 12px;

        &:last-of-type {
            margin-bottom: 0;
        }
    }
}
</style>